import { render, staticRenderFns } from "./HourOverview.vue?vue&type=template&id=38055c08&scoped=true&"
import script from "./HourOverview.vue?vue&type=script&lang=ts&"
export * from "./HourOverview.vue?vue&type=script&lang=ts&"
import style0 from "./HourOverview.vue?vue&type=style&index=0&id=38055c08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38055c08",
  null
  
)

export default component.exports